import styled, { css } from "styled-components"

import { minWidth, when } from "utils"

export const Container = styled.details`
  position: relative;
  display: inline;

  ${({ isArticleFAQ }) =>
    isArticleFAQ
      ? css`
          background: #fafafa;

          & > h3 {
            font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 2.1rem;
            line-height: 1.35;

            ${minWidth.tablet`
              font-size: 1.8rem;
              line-height: 1.7778;
            `}
          }

          p {
            margin: 0;
            padding: 0 2.5rem 2.5rem;
            font-size: 1.6rem;
            line-height: 1.375;
            a {
              text-decoration: underline;
              font-weight: medium;
              color: #b5471f;
            }
          }

          span div {
            a {
              color: ${({ theme }) => theme.colors.text.color};
              font-size: 1.6rem;
              }
            li {
              font-size: 1.6rem;
            }
          }
        }
        `
      : css`
          border-radius: 0.5rem;
          background: #fff;
          box-shadow: 0 2px 7px rgba(145, 145, 145, 0.35);

          & > h3 {
            font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 2.1rem;
            line-height: 1.35;

            ${minWidth.tablet`
              font-size: 2.2rem;
              line-height: 1.45;
            `}
          }

          p {
            margin: 0;
            padding: 0 4rem 2.4rem 3rem;
            font-size: 1.6rem;
            line-height: 1.375;
          }
        `}
`

export const Summary = styled.summary`
  padding: ${({ isArticleFAQ }) =>
    isArticleFAQ ? "2.5rem 5rem 2.5rem 2.5rem" : "2.4rem 5rem 2.4rem 3rem"};
  display: flex;
  list-style: none;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border: none;
  background: none;
  outline: none;

  ::-webkit-details-marker {
    display: none;
  }

  &:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }

  &:hover {
    opacity: 0.8;
  }

  ${minWidth.tablet`
    padding: ${({ isArticleFAQ }) =>
      isArticleFAQ ? "2.5rem 4rem 2.5rem 2.5rem" : "2.4rem 4rem 2.4rem 3rem"};
  `}
`

export const IconContainer = styled.div`
  margin-right: 0.6rem;
`
